import { format, parse } from 'date-fns';

export const formatDateFromServiceToUi = (date: string) =>
  date && date.length > 0 ? format(new Date(date), 'dd/MM/yyyy') : '';

export const revertFormatDateFromServiceToUi = (date: string) =>
  parse(date, 'dd/MM/yyyy', new Date());
